// extracted by mini-css-extract-plugin
module.exports = {"item":"zzZpw","link":"uhlKu","titles":"_0AA-z","desktop-body":"_2hkJL"};